<template>
  <b-card>
    <b-form
      novalidate
      @submit.prevent="submitForm"
    >
      <validation-observer ref="formRef">
        <b-row>
          <b-col
            md="12"
            class="d-flex justify-content-between align-items-center"
          >
            <h3>{{ group? 'Edit': 'Create New' }} modifier group</h3>
            <b-button
              type="submit"
              :disabled="submitting"
              variant="primary"
            >
              <b-spinner
                v-if="submitting"
                small
              />
              <span v-else>Save</span>
            </b-button>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Name En"
              rules="required"
            >
              <b-form-group
                label="Name En*"
                label-for="group-name-en"
              >
                <b-form-input
                  id="group-name-en"
                  v-model="formData.name.en"
                  placeholder="Name En"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Name Ar"
              rules="required"
            >
              <b-form-group
                label="Name Ar*"
                label-for="group-name-ar"
              >
                <b-form-input
                  id="group-name-ar"
                  v-model="formData.name.ar"
                  placeholder="Name Ar"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="12">
            <h4>Rules</h4>
          </b-col>
          <b-col
            md="4"
            class="d-flex align-items-center"
          >
            <b-form-checkbox
              v-model="formData.rules.required"
            >The customer is required to select an item</b-form-checkbox>
          </b-col>
          <b-col md="4">
            <validation-provider
              #default="{ errors }"
              name="The minimum amount of selection"
              rules="required"
            >
              <b-form-group
                label="The minimum amount of selection"
                label-for="group-min-amount"
              >
                <b-form-input
                  id="group-min-amount"
                  v-model.number="formData.rules.minimumNumberOfSelections"
                  placeholder="The minimum amount of selection"
                  type="number"
                />
                <span
                  v-if="selectionsValuesValidation"
                  class="text-danger"
                >Minimum amount cannot be larger than maximum amount</span>
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="4">
            <validation-provider
              #default="{ errors }"
              name="The maximum amount of selection"
              rules="required"
            >
              <b-form-group
                label="The maximum amount of selection"
                label-for="group-max-amount"
              >
                <b-form-input
                  id="group-max-amount"
                  v-model.number="formData.rules.maximumAllowedSelection"
                  placeholder="The maximum amount of selection"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            md="12"
            class="d-flex justify-content-between align-items-center"
          >
            <h4>Selections</h4>
            <b-form-checkbox
              v-model="formData.rules.allowMultipleSelections"
              switch
              :disabled="+formData.rules.maximumAllowedSelection <= 1"
            >Multiple Selection</b-form-checkbox>

            <b-button
              variant="primary"
              @click="createNewSelection"
            >
              Add new selection
            </b-button>
          </b-col>
          <b-col md="12">
            <b-row
              v-for="(selection, ix) in formData.selections"
              :key="selection.localId"
            >
              <b-col
                md="12"
                class="d-flex justify-content-between align-items-center"
              >
                <span>Option No. #{{ ix + 1 }}</span>
                <b-button
                  class="btn-icon rounded-circle"
                  variant="flat-danger"
                  @click="removeSelection(ix)"
                >
                  <feather-icon
                    icon="TrashIcon"
                  />
                </b-button>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Option Name En"
                  rules="required"
                >
                  <b-form-group
                    label="Option Name En"
                    :label-for="`option-${ix}-name-en`"
                  >
                    <b-form-input
                      :id="`option-${ix}-name-en`"
                      v-model="selection.name.en"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Option Name Ar"
                  rules="required"
                >
                  <b-form-group
                    label="Option Name Ar"
                    :label-for="`option-${ix}-name-ar`"
                  >
                    <b-form-input
                      :id="`option-${ix}-name-ar`"
                      v-model="selection.name.ar"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Option Price"
                  rules="required"
                >
                  <b-form-group
                    label="Option Price"
                    :label-for="`option-${ix}-price`"
                  >
                    <b-form-input
                      :id="`option-${ix}-price`"
                      v-model.number="selection.price"
                      type="number"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>

            </b-row>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>
  </b-card>
</template>

<script>
import {
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BCard,
  BSpinner,
  BRow,
  BCol,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { computed, ref, watch } from '@vue/composition-api'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormCheckbox,
    BSpinner,
    BButton,
    BCard,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
  },
  props: {
    group: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const businessId = ctx.root.$route.params.id
    const formData = ref({
      name: {
        en: '',
        ar: '',
      },
      rules: {
        maximumAllowedSelection: 1,
        minimumNumberOfSelections: 1,
        allowMultipleSelections: false,
        required: false,
      },
      selections: [],
    })
    const selectionsValuesValidation = computed(() => formData.value.rules.minimumNumberOfSelections > formData.value.rules.maximumAllowedSelection)

    const createNewSelection = () => {
      formData.value.selections.push({
        price: undefined,
        name: {
          en: '',
          ar: '',
        },
        localId: Math.random().toString(),
      })
    }
    const removeSelection = ix => {
      formData.value.selections.splice(ix, 1)
    }
    watch(
      () => formData.value.rules.maximumAllowedSelection,
      () => {
        if (+formData.value.rules.maximumAllowedSelection <= 1) {
          formData.value.rules.allowMultipleSelections = false
        }
      },
    )

    const submitting = ref(false)

    const submitForm = async () => {
      const res = await ctx.refs.formRef.validate()
      if (!res || selectionsValuesValidation.value) return
      const PAYLOAD = {
        rules: {
          maximumAllowedSelection:
            +formData.value.rules.maximumAllowedSelection || 0,
          minimumNumberOfSelections:
            +formData.value.rules.minimumNumberOfSelections || 0,
          required: formData.value.rules.required,
          allowMultipleSelections: formData.value.rules.allowMultipleSelections,
        },
        name: formData.value.name,
        selections: formData.value.selections.map(el => ({
          price: el?.price ? +el.price : 0,
          name: {
            en: el.name.en,
            ar: el.name.ar,
          },
        })),
      }
      try {
        submitting.value = true
        if (props.group) {
          await ctx.root.$store.dispatch('business/updateModifierGroup', {
            payload: {
              ...PAYLOAD,
              businessId,
            },
            groupId: props.group.id,
          })
          await ctx.root.$store.dispatch('business/transitionGroup', {
            group: {
              requestedChange: {},
              ...PAYLOAD,
              id: props.group.id,
            },
            body: {
              action: 'APPROVE',
            },
          })
          ctx.emit('updated')
        } else {
          const result = await ctx.root.$store.dispatch('business/createModifierGroup', {
            ...PAYLOAD,
            businessId,
          })
          await ctx.root.$store.dispatch('business/transitionGroup', {
            group: result.data.data.data,
            body: {
              action: 'APPROVE',
            },
          })
          ctx.emit('created')
        }
      } finally {
        submitting.value = false
      }
    }
    if (props.group) {
      formData.value = JSON.parse(JSON.stringify(props.group))
      formData.value.selections = formData.value.selections.map(el => ({
        ...el,
        localId: Math.random().toString(),
      }))
    }
    return {
      createNewSelection,
      removeSelection,
      submitForm,
      required,
      formData,
      submitting,
      selectionsValuesValidation,
    }
  },
}
</script>

<style>

</style>
